export default __webpack_public_path__ + "static/waldin-bcbe300cb74ea0681833683c5c13783d.jpg";